import { Link } from 'react-router-dom';
import { Beaker } from 'lucide-react';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import Seo from '../seo/Seo';
import { useAuth } from '../context/AuthContext';

const TEST_PAGE_LINKS = [
  {
    to: '/ai-tools/ai-2d-floorplan-designer',
    label: 'AI 2D Floor Plan Designer',
    description: 'Public manual 2D floor plan designer using the shared editor.',
  },
  {
    to: '/test-2d-floor-plan-designer',
    label: '2D Floor Plan Designer Test',
    description: 'Manually draw a floor plan in Konva and preview it in Three.js.',
  },
  {
    to: '/test/floorplan-to-3d-image',
    label: '2D Floor Plan To 3D Image',
    description: 'Convert a 2D floor plan into a 3D-style rendered image.',
  },
  {
    to: '/test/floorplan-room-to-realistic-image',
    label: 'Floor Plan Room To Realistic Image',
    description: 'Generate a realistic room image from a selected floor plan area.',
  },
  {
    to: '/test/nanobanan-pro',
    label: 'Nano Banan Pro Test Page',
    description: 'Send an image and custom prompt to Gemini Nano Banan Pro and receive a generated image.',
  },
  {
    to: '/test/veo-floorplan-video',
    label: 'Veo Floor Plan Animation Test',
    description:
      'Generate a video transition between a 2D floor plan and a 3D floor plan using Google Veo 3.1.',
  },
  {
    to: '/test/cubicasa-mask-debug',
    label: 'CubiCasa Mask Debugger',
    description: 'Upload a floor plan and inspect raw CubiCasa masks before OpenCV cleanup.',
  },
  {
    to: '/dev/box-test',
    label: 'Furniture Box Detection Test',
    description: 'Internal tool for testing furniture bounding box detection.',
  },
];

function TestPagesPage() {
  const { user } = useAuth();

  return (
    <>
      <Seo
        title="Test Pages | MyRoomsAI"
        description="Admin-only internal test pages for MyRoomsAI development tools."
        canonicalPath="/test-pages"
        noindex
      />
      <Navbar />
      <main className="container admin-page test-pages-page">
        <div className="admin-page-header">
          <Beaker size={28} strokeWidth={2} aria-hidden />
          <div>
            <h1>Test Pages</h1>
            <p className="admin-page-subtitle">
              Admin-only development and QA tools{user?.email ? ` · Signed in as ${user.email}` : ''}
            </p>
          </div>
        </div>

        <section className="admin-page-section">
          <h2>Available test pages</h2>
          <ul className="admin-page-links test-pages-list">
            {TEST_PAGE_LINKS.map(({ to, label, description }) => (
              <li key={to} className="test-pages-list-item">
                <Link to={to}>{label}</Link>
                <p className="test-pages-list-desc">{description}</p>
              </li>
            ))}
          </ul>
        </section>

        <section className="admin-page-section">
          <h2>Admin</h2>
          <ul className="admin-page-links">
            <li>
              <Link to="/admin">Back to Admin dashboard</Link>
            </li>
            <li>
              <Link to="/projects">Projects</Link>
            </li>
          </ul>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default TestPagesPage;
